export const POST_LOGIN_REDIRECT_KEY = 'cl-hybrid.postLoginRedirect'

export function isKeycloakRequiredError(error: unknown): boolean {
    return (
        typeof error === 'object' &&
        error !== null &&
        'status' in error &&
        (error as { status?: unknown }).status === 409
    )
}

export function getKeycloakInitOptions() {
    return {
        // No silent iframe. This realm sends frame-ancestors 'self', so the
        // hidden check never posts back and keycloak.init() never resolves.
        // A callback on /login is still processed, and a 409 starts a full redirect.
        checkLoginIframe: false,
        pkceMethod: 'S256' as const,
        responseMode: 'query' as const,
        enableLogging: process.env.NODE_ENV === 'development'
    }
}

export function rememberPostLoginRedirect(path: string) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path)
}

export function consumeStoredPostLoginRedirect(): string | undefined {
    const stored = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY)
    if (!stored) return
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY)
    return stored
}

let sessionPromise: Promise<void> | undefined

export function establishKeycloakSession(run: () => Promise<void>) {
    if (!sessionPromise) {
        sessionPromise = run().catch(error => {
            sessionPromise = undefined
            throw error
        })
    }
    return sessionPromise
}
